module.exports = __webpack_public_path__ + "img/04.f5a4f140.jpg";